import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function EmptyState(props) {
    const { title, description, action, glyph, className } = props;
    return (_jsxs("div", { className: className, "data-empty-state": true, style: {
            border: '1px dashed var(--border-strong)',
            borderRadius: 'var(--radius-card)',
            padding: 'var(--space-8) var(--space-6)',
            textAlign: 'center',
            fontFamily: 'var(--font-ui)',
            color: 'var(--text-muted)',
        }, children: [glyph ? (_jsx("div", { "aria-hidden": "true", style: { marginBottom: 'var(--space-3)', fontSize: 'var(--font-size-xl)' }, children: glyph })) : null, _jsx("h3", { style: {
                    margin: 0,
                    fontFamily: 'var(--font-ui)',
                    fontSize: 'var(--font-size-md)',
                    color: 'var(--text)',
                }, children: title }), description ? (_jsx("p", { style: { margin: 'var(--space-2) auto 0', maxWidth: '48ch', color: 'var(--text-muted)' }, children: description })) : null, action ? (_jsx("div", { style: { marginTop: 'var(--space-4)', display: 'inline-flex', gap: 'var(--space-2)' }, children: action })) : null] }));
}
//# sourceMappingURL=EmptyState.js.map